
/**
 * `Lightbox` - A simple lightbox that contains a close button and the content provided via slot.
 */
import ComponentInitializeDispatcher from '@owc-utils/Mixins/ComponentInitializeDispatcher';
import { LIGHTBOX_EVENTS, LIGHTBOX_CLASSES, FOCUS_STACK_LIGHTBOX_CONTEXT } from './Lightbox.config';
import getAccessibilityStackInstance from '@owc-utils/common/AccessibilityFocusStackHelper';
import ValidationBoxWrapper from '@owc-packages/ValidationBox/src';

const accessibilityHelper = getAccessibilityStackInstance();

export default ComponentInitializeDispatcher.extend({
  name: 'owc-lightbox',
  components: {
    ValidationBoxWrapper,
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      scrollLockElements: [document.body, document.documentElement] as HTMLElement[],
    };
  },
  methods: {
    closeLightbox(): void {
      this.$emit(LIGHTBOX_EVENTS.close);
      this.unlockWindow();
    },
    lockWindow(): void {
      this.scrollLockElements.forEach(element => element.classList.add(LIGHTBOX_CLASSES.lockClass));
    },
    unlockWindow(): void {
      this.scrollLockElements.forEach(element => {
        element.classList.remove(LIGHTBOX_CLASSES.lockClass);
      });
    },
    bindKeyboardKeys(): void {
      document.addEventListener('keydown', this.handleKeyboardKeys);

      this.$nextTick(() =>
        accessibilityHelper.setFocusKeyboardTrap(this.$el, FOCUS_STACK_LIGHTBOX_CONTEXT, true),
      );
    },
    unbindKeyboardKeys(): void {
      document.removeEventListener('keydown', this.handleKeyboardKeys);

      accessibilityHelper.removeKeyboardTrap(FOCUS_STACK_LIGHTBOX_CONTEXT);
    },
    handleKeyboardKeys(event: KeyboardEvent): void {
      if (event.key === 'Escape') {
        this.closeLightbox();
      }
    },
    handleOpen(): void {
      this.lockWindow();
      this.bindKeyboardKeys();
    },
    handleClose(): void {
      this.unlockWindow();
      this.unbindKeyboardKeys();
    },
  },
  watch: {
    isOpen(newValue) {
      if (newValue) {
        this.handleOpen();
      } else {
        this.handleClose();
      }
    },
  },
});
